import {Action} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {EntityConfiguracao} from './entity-configuracao.model';
import * as Actions from './entity-configuracao.actions';
import {ActionsExample, entityReducer, initial} from '~utils/ngrx-util';

export const entityConfigFeatureKey = 'entityConfig';

export interface State extends EntityState<EntityConfiguracao> {
}

export const adapter: EntityAdapter<EntityConfiguracao> = createEntityAdapter<EntityConfiguracao>();

export const initialState: State = adapter.getInitialState(initial);

const entityActions: ActionsExample<EntityConfiguracao> = {
  add: Actions.addEntityConfig,
  adds: Actions.addEntityConfigs,
  clear: Actions.clearEntityConfig,
  remove: Actions.deleteEntityConfig,
  removes: Actions.deleteEntityConfigs,
  load: Actions.loadEntityConfig,
  update: Actions.updateEntityConfig,
  updates: Actions.updateEntityConfigs,
  upsert: Actions.upsertEntityConfig,
  upserts: Actions.upsertEntityConfigs,
};

const entityConfiguracaoReducer = entityReducer(initialState, entityActions, adapter);

export function reducer(state: State | undefined, action: Action): State {
  return entityConfiguracaoReducer(state, action);
}

export const {selectIds, selectEntities, selectAll, selectTotal} = adapter.getSelectors();


